import React from "react";
import { Row, Table, Badge, Col, UncontrolledTooltip } from "reactstrap";
import { productHeaders } from "../../../usersConfig";
import Pagination from "../../../../../../shared/components/pagination/Pagination";
import * as env from "../../../../../../env";
import FormComponent from "./form";
import Slider from "react-slide-out";
import client from "../../../../../../shared/api-client";
import ProductActions from "./ProductActions";
import ProductOrderInfo from "./ProductOrderInfo";
import Modal from "../../../../../../shared/modal";
import * as CurrencyFormat from "react-currency-format";
import getUpdated from "../../../../../../shared/objGetUpdated";
import * as products from "../../../../../../shared/service/products";
import * as users from "../../../../../../shared/service/users";
import * as validate from "../../../../../../shared/validate";
import ProfileProductProxies from "./ProfileProductProxies";
import ProfileProductProxiesTextArea from "./ProfileProductProxiesTextArea";
import { Link } from "react-router-dom";
import RecycleIcon from "mdi-react/RecycleIcon";
import RefreshIcon from "mdi-react/RefreshIcon";
import CancelIcon from "mdi-react/CancelIcon";

class ProfileProducts extends React.Component {
  state = {
    isOpen: false,
    openProxies: false,
    openProxiesArea: false,
    subscriptions: [],
    processing: false,
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
    formValues: {
      proxies: [],
      source: "manual",
    },
    locations: [],
    products: [],
    subnets: [],
    usages: [],
    progress: "",
    show: false,
    edit: [],
    filters: [],
    filtersUpdated: true,
    userPagination: {
      pageSize: env.RECORDS_PER_PAGE,
      currentPage: 1,
    },
  };

  updateComponent = true;

  componentDidMount() {
    if (
      this.props.id !== undefined &&
      window.location.pathname.includes("users/details")
    ) {
      this.getSubscriptions();
    }

    this.getLocations();
    this.getPackages();
    this.getUseCases();
    this.getSubnets();
  }

  filter = (filters) => {
    this.setState(
      {
        filters: filters,
        filtersUpdated: true,
        userPagination: {
          pageSize: env.RECORDS_PER_PAGE,
          currentPage: 1,
        },
      },
      () => {
        this.updateComponent = true;
        this.getSubscriptions();
      }
    );
  };

  getSubnets = () => {
    client(`subnets.php`).then(
      (subnets) => {
        this.setState({ subnets: subnets }, () => {
          this.updateComponent = true;
        });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  getUseCases = () => {
    client(`proxy_usage.php`).then(
      (usages) => {
        this.setState({ usages: usages.data }, () => {
          this.updateComponent = true;
        });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  getLocations = () => {
    // client(`proxy_lmp_locations.php`).then(
    //   (response) => {
    //     this.setState(
    //       {
    //         locations: response,
    //       },
    //       () => {
    //         this.updateComponent = true;
    //       }
    //     );
    //   },
    //   (error) => {
    //     console.error(error);
    //   }
    // );
  };

  getPackages = () => {
    client(`packages.php`).then((response) => {
      this.setState({ products: response.packages }, () => {
        this.updateComponent = true;
      });
    });
  };

  onChangePage = (pagination) => {
    if (pagination.currentPage !== this.state.userPagination.currentPage) {
      this.setState(
        { userPagination: pagination, filtersUpdated: false },
        () => {
          this.updateComponent = true;
          this.getSubscriptions();
        }
      );
    }
  };

  getSubscriptions = () => {
    let params = this.state.filters;

    params["pagination"] = this.state.userPagination;

    if (this.props.id !== undefined) {
      params["uid"] = this.props.id;
    }

    this.setState(
      {
        progress: "Loading ...",
      },
      () => {
        products.get(params).then((response) => {
          this.setState(
            {
              isOpen: false,
              subscriptions: response.data,
              progress: response.data.length === 0 ? "No record found" : "",
            },
            () => {
              this.updateComponent = true;

              if (this.state.filtersUpdated === true) {
                products.getTotal(params).then((response) => {
                  this.setState(
                    {
                      records: response.total,
                    },
                    () => {
                      this.updateComponent = true;
                    }
                  );
                });
              }
            }
          );
        });
      }
    );
  };

  printSubnets = (proxies) => {
    let subnets = [];

    proxies.map((proxy) => {
      if (!subnets.includes(proxy.subnet)) {
        subnets.push(proxy.subnet);
      }

      return proxy;
    });

    return subnets.length > 0 ? (
      <React.Fragment>
        <br />
        <small>
          <strong>Subnets:</strong>
          {subnets.map((subnet, index) => (
            <span className="w3-badge" key={subnet}>
              {subnet}
            </span>
          ))}
        </small>
      </React.Fragment>
    ) : (
      ""
    );
  };

  printRecords = () => {
    return (
      <React.Fragment>
        {this.state.subscriptions.map((obj) => (
          <tr key={obj.order_id + Math.random()}>
            <td>{obj.product_id}</td>
            {this.props.id === undefined ? (
              <React.Fragment>
                <td>
                  <Link to={`/users/details/${obj.uid}`}>{obj.uid}</Link>
                </td>
              </React.Fragment>
            ) : (
              <React.Fragment></React.Fragment>
            )}
            <td>
              {obj.display_name}
              {obj.recurrence == "yes" ? (
                <React.Fragment>
                  <RecycleIcon
                    size={20}
                    color="#66d568"
                    id={`Auto-Renewal-${obj.order_id}`}
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target={`Auto-Renewal-${obj.order_id}`}
                  >
                    Auto renewal
                  </UncontrolledTooltip>
                </React.Fragment>
              ) : (
                ""
              )}
              {obj.status == "terminate_pending" ? (
                <React.Fragment>
                  <CancelIcon
                    size={20}
                    color="#f6da6e"
                    id={`Cancellation-Request-${obj.order_id}`}
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target={`Cancellation-Request-${obj.order_id}`}
                  >
                    Cancellation Request
                  </UncontrolledTooltip>
                </React.Fragment>
              ) : (
                ""
              )}
              {obj.refresh == "yes" ? (
                <React.Fragment>
                  <RefreshIcon
                    size={20}
                    color="#f6da6e"
                    id={`refresh-Request-${obj.order_id}`}
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target={`refresh-Request-${obj.order_id}`}
                  >
                    Refresh Request
                  </UncontrolledTooltip>
                </React.Fragment>
              ) : (
                ""
              )}
              {obj.display_name !== obj.name ? (
                <React.Fragment>
                  <br />
                  <small>
                    <i>{obj.name}</i>
                  </small>
                </React.Fragment>
              ) : (
                ""
              )}

              <br />
              <ProductOrderInfo oid={obj.order_id}></ProductOrderInfo>
              {obj.subscription_id !== "" ? (
                <React.Fragment>
                  <br />
                  <small>
                    <strong>Subscription Id:</strong> {obj.subscription_id}
                  </small>
                </React.Fragment>
              ) : (
                <React.Fragment></React.Fragment>
              )}
              {obj.geo !== null && obj.geo !== "" ? (
                <React.Fragment>
                  <br />
                  <small>
                    <strong>Geo:</strong> {obj.geo}
                  </small>
                </React.Fragment>
              ) : (
                ""
              )}
              {this.printSubnets(obj.proxies)}
            </td>
            <td>{obj.subscribed_on}</td>
            <td>{obj.valid_till}</td>
            <td className="textRight">
              <CurrencyFormat
                value={obj.cost}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
            <td>
              {obj.status === "active" ? (
                <Badge color="success" className="capitalizeCase ">
                  {obj.status}
                </Badge>
              ) : obj.status === "terminate_pending" ? (
                <Badge color="warning" className="capitalizeCase">
                  Cancellation Request
                </Badge>
              ) : obj.status === "refresh_pending" ? (
                <Badge color="primary" className="capitalizeCase">
                  Refresh Request
                </Badge>
              ) : (
                <Badge color="danger" className="capitalizeCase">
                  {obj.status}
                </Badge>
              )}
            </td>
            <td>
              <ProductActions
                onEditClicked={(obj) => this.toggleEdit(obj)}
                onCredentialsClicked={(obj) => this.toggleEdit(obj)}
                product={obj}
                getProxyListBySubnet={(obj) => this.getProxyList(obj, true)}
                refreshProxyListBySubnet={(obj) =>
                  this.refreshProxyListBySubnet(obj, true)
                }
                getProxyList={(obj) => this.getProxyList(obj, false)}
                repurchase={(obj) => this.repurchase(obj)}
                no={obj.proxies.length}
                onTerminateClick={(obj) => {
                  this.terminate(obj);
                }}
                approveTerminate={(obj) => this.approveTerminate(obj)}
                rejectTerminate={(obj) => this.rejectTerminate(obj)}
                approveRefresh={(obj) => this.approveRefresh(obj)}
                rejectRefresh={(obj) => this.rejectRefresh(obj)}
                approveResidential={(obj) => this.approveResidential(obj)}
              />
            </td>
          </tr>
        ))}
      </React.Fragment>
    );
  };

  pagination = () => {
    return this.state.records > env.RECORDS_PER_PAGE ? (
      <div className="audit-trail-footer">
        <Pagination
          items={this.state.subscriptions}
          records={this.state.records}
          initialPage={this.state.userPagination.currentPage}
          onChangePage={(pagination) => this.onChangePage(pagination)}
          pageSize={env.RECORDS_PER_PAGE}
        />
      </div>
    ) : (
      ""
    );
  };

  activateTrailProxy = () => {
    let usProxy = this.state.subnets
      .filter(
        (subnet) =>
          subnet.geo_mm_cc === "US" && subnet.proxies.available_proxies > 0
      )
      .random();

    let ukProxy = this.state.subnets
      .filter(
        (subnet) =>
          subnet.geo_mm_cc === "GB" && subnet.proxies.available_proxies > 0
      )
      .random();

    let formValues = {
      concurrent_connection: "",
      cost: "0",
      name: "Trial Proxies",
      payment: "credit",
      proxies: [
        {
          lid: usProxy.lid,
          location: usProxy.geo_maxmind,
          no: 1,
          sid: usProxy.sid,
          subnet: usProxy.subnet,
        },
        {
          lid: ukProxy.lid,
          location: ukProxy.geo_maxmind,
          no: 1,
          sid: ukProxy.sid,
          subnet: ukProxy.subnet,
        },
      ],
      source: "test",
      type: "Premium",
      uid: "66",
      valid: 3,
    };

    this.setState({ formValues }, () => {
      this.submit();
    });
  };

  toggleAddNew = () => {
    this.setState({ edit: [], isOpen: true }, () => {
      this.updateComponent = true;
    });
  };

  toggleEdit = (product) => {
    this.setState({ edit: product, isOpen: true }, () => {
      this.updateComponent = true;
    });
  };

  refreshProxyListBySubnet = (product, bySubnet) => {
    this.setState({ edit: product, openProxies: true }, () => {
      this.updateComponent = true;
    });
  };

  getProxyList = (product, bySubnet) => {
    if (bySubnet === true) {
      this.setState({ edit: product, openProxies: true }, () => {
        this.updateComponent = true;
      });
    } else {
      this.setState({ edit: product, openProxiesArea: true }, () => {
        this.updateComponent = true;
      });
    }
  };

  repurchase = (product) => {
    products.repurchase(product.product_id).then(
      (response) => {
        this.setState(
          {
            show: true,
            errors: [],
            success: response._user_message,
          },
          () => {
            this.updateComponent = true;
          }
        );
        this.getSubscriptions();
      },
      (error) => {
        this.setState(
          {
            show: true,
            errors: [error._user_message],
            success: "",
          },
          () => {
            this.updateComponent = true;
          }
        );
      }
    );
  };

  terminate = (product) => {
    this.updateComponent = true;

    products.terminate(product.product_id).then(
      (response) => {
        this.setState(
          {
            show: true,
            errors: [],
            success: response._user_message,
          },
          () => {
            this.updateComponent = true;
          }
        );
        this.getSubscriptions();
      },
      (error) => {
        this.setState(
          {
            show: true,
            errors: [error._user_message],
            success: "",
          },
          () => {
            this.updateComponent = true;
          }
        );
      }
    );
  };

  approveTerminate = (product) => {
    this.updateComponent = true;

    products.approveTerminate(product.product_id).then(
      (response) => {
        this.setState(
          {
            show: true,
            errors: [],
            success: response._user_message,
          },
          () => {
            this.updateComponent = true;
          }
        );
        this.getSubscriptions();
      },
      (error) => {
        this.setState(
          {
            show: true,
            errors: [error._user_message],
            success: "",
          },
          () => {
            this.updateComponent = true;
          }
        );
      }
    );
  };

  rejectTerminate = (product) => {
    this.updateComponent = true;

    products.rejectTerminate(product.product_id).then(
      (response) => {
        this.setState(
          {
            show: true,
            errors: [],
            success: response._user_message,
          },
          () => {
            this.updateComponent = true;
          }
        );
        this.getSubscriptions();
      },
      (error) => {
        this.setState(
          {
            show: true,
            errors: [error._user_message],
            success: "",
          },
          () => {
            this.updateComponent = true;
          }
        );
      }
    );
  };

  approveResidential = (product) => {
    console.log("approveResidential", product);
  };

  approveRefresh = (product) => {
    this.updateComponent = true;

    products.approveRefresh(product.product_id).then(
      (response) => {
        this.setState(
          {
            show: true,
            errors: [],
            success: response._user_message,
          },
          () => {
            this.updateComponent = true;
          }
        );
        this.getSubscriptions();
      },
      (error) => {
        this.setState(
          {
            show: true,
            errors: [error._user_message],
            success: "",
          },
          () => {
            this.updateComponent = true;
          }
        );
      }
    );
  };

  rejectRefresh = (product) => {
    this.updateComponent = true;

    products.rejectRefresh(product.product_id).then(
      (response) => {
        this.setState(
          {
            show: true,
            errors: [],
            success: response._user_message,
          },
          () => {
            this.updateComponent = true;
          }
        );
        this.getSubscriptions();
      },
      (error) => {
        this.setState(
          {
            show: true,
            errors: [error._user_message],
            success: "",
          },
          () => {
            this.updateComponent = true;
          }
        );
      }
    );
  };

  printActions = () => {
    return this.state.subnets.length > 0 ? (
      <React.Fragment>
        <button
          type="button"
          onClick={() => this.activateTrailProxy()}
          className="btn btn-sm btn-primary"
        >
          Activate Trial Proxy
        </button>
        <button
          type="button"
          onClick={() => this.toggleAddNew()}
          className="btn btn-sm btn-primary"
        >
          Assign Product
        </button>
      </React.Fragment>
    ) : (
      ""
    );
  };

  handleForm = (formValues) => {
    this.setState({ formValues }, () => {
      this.updateComponent = true;
    });
  };

  updateProxiesTextarea = () => {
    if (this.state.formValues.product_id !== undefined) {
      products
        .updateProxies(
          this.state.formValues.product_id,
          this.state.formValues.uid,
          {
            assign: this.state.formValues.proxiesList,
          }
        )
        .then(
          (response) => {
            this.setState(
              {
                openProxiesArea: false,
                show: true,
                success: response._user_message,
                errors: [],
              },
              () => {
                this.updateComponent = true;
                this.getSubscriptions();
              }
            );
          },
          (error) => {
            this.setState(
              {
                show: true,
                errors: error._user_message,
                success: "",
              },
              () => {
                this.updateComponent = true;
              }
            );
          }
        );
    }
  };
  updateProxies = () => {
    if (this.state.formValues.product_id !== undefined) {
      let proxiesList = [];
      this.state.formValues.proxies.map((subnet) => {
        subnet.proxies.map((proxy) => {
          proxiesList.push(proxy.name);

          return proxy;
        });

        return subnet;
      });

      // TODO
      if (proxiesList.length > 0) {
        products
          .updateProxies(
            this.state.formValues.product_id,
            this.state.formValues.uid,
            {
              assign: proxiesList.toString(),
            }
          )
          .then(
            (response) => {
              this.setState(
                {
                  openProxies: false,
                  show: true,
                  success: response._user_message,
                  errors: [],
                },
                () => {
                  this.updateComponent = true;
                  this.getSubscriptions();
                }
              );
            },
            (error) => {
              this.setState(
                {
                  show: true,
                  errors: error._user_message,
                  success: "",
                },
                () => {
                  this.updateComponent = true;
                }
              );
            }
          );
      }
    }
  };

  submitForm = () => {
    if (this.state.processing === true) {
      return false;
    }

    let errors = [];

    if (
      this.state.formValues.cost === undefined ||
      !validate.number(this.state.formValues.cost) ||
      this.state.formValues.cost <= 0
    ) {
      errors.push("Please enter a valid cost.");
    }

    if (
      this.state.formValues.valid === undefined ||
      !validate.number(this.state.formValues.valid) ||
      this.state.formValues.valid <= 0
    ) {
      errors.push("Please select the valid days.");
    }

    console.log(
      "this.state.formValues",
      this.state.formValues.name
        .toLowerCase()
        .toLowerCase()
        .includes("residential")
    );

    if (
      !this.state.formValues.name.toLowerCase().includes("residential") &&
      (this.state.formValues.proxies === undefined ||
        this.state.formValues.proxies.length <= 0)
    ) {
      errors.push("Please select the proxies.");
    }

    if (errors.length > 0) {
      this.setState(
        {
          show: true,
          success: "",
          errors: errors,
        },
        () => {
          this.updateComponent = true;
        }
      );

      return false;
    }

    this.setState({ processing: true }, () => {
      let uid =
        this.props.id === undefined
          ? this.state.formValues.uid
            ? this.state.formValues.uid
            : 0
          : this.props.id;

      users.credit(uid).then((credit) => {
        if (this.state.formValues.product_id !== undefined) {
          this.submit();
          return true;
        } else if (this.state.formValues.cost <= credit) {
          this.submit();
          return true;
        } else {
          this.setState({
            show: true,
            success: "",
            processing: false,
            errors: [
              <React.Fragment>
                User does not have sufficient balance.&nbsp;
                <small>
                  <i>
                    (Available credits :
                    <CurrencyFormat
                      value={credit}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                    />
                    , Required credits :{" "}
                    <CurrencyFormat
                      value={this.state.formValues.cost}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                    />
                    )
                  </i>
                </small>
              </React.Fragment>,
            ],
          });
        }
      });
    });
  };

  submit = () => {
    let body = {};

    if (this.state.formValues.product_id !== undefined) {
      let currentSubscription = this.state.subscriptions.filter(
        (subscription) =>
          subscription.product_id === this.state.formValues.product_id
      );

      if (currentSubscription.length > 0) {
        let formValues = this.state.formValues;
        delete formValues.concurrentConnection;
        delete formValues.subnets;
        delete formValues.subnet_suggestions;
        delete formValues.noOfProxies;

        body = getUpdated(currentSubscription[0], formValues);

        if (formValues.proxiesUpdated === true) {
          body.proxies = formValues.proxies;
        }
        delete formValues.proxiesUpdated;
        delete body.proxiesUpdated;

        if (Object.keys(body).length > 0) {
          body.product_id = formValues.product_id;
        }
      }
    } else {
      let product = this.state.products.filter(
        (product) => product.id === this.state.formValues.type
      );
      let type = this.state.formValues.type;

      if (product.length > 0) {
        type = product[0].type;
      }

      body = {
        uid: this.props.id,
        product_id: this.state.formValues.product_id,
        parent_id:
          this.state.formValues.parent_id !== undefined
            ? this.state.formValues.parent_id
            : "",
        name: this.state.formValues.name,
        display_name: this.state.formValues.display_name,
        payment: "credit",
        source:
          this.state.formValues.source !== undefined
            ? this.state.formValues.source
            : "manual",
        type: type === "Private" ? type : "Premium",
        cost: this.state.formValues.cost,
        valid: this.state.formValues.valid,
        usage:
          this.state.formValues.usage !== undefined
            ? this.state.formValues.usage
            : "",
        website:
          this.state.formValues.website !== undefined
            ? this.state.formValues.website
            : "",
        concurrent_connection:
          this.state.formValues.concurrent_connection !== undefined
            ? this.state.formValues.concurrent_connection
            : "",
        notes:
          this.state.formValues.notes !== undefined
            ? this.state.formValues.notes
            : "",
        proxies: this.state.formValues.proxies,
        tags: this.state.formValues.tags,
        bandwidth: this.state.formValues.bandwidth,
        domains: this.state.formValues.domains,
        description: this.state.formValues.description,
      };
    }

    if (Object.keys(body).length === 0) {
      this.setState({ isOpen: false });
    } else {
      client(`custom_proxy.php`, {
        method: body.product_id !== undefined ? "POST" : "PUT",
        body: body,
      }).then(
        (response) => {
          this.setState(
            {
              show: true,
              success: response._user_message,
              errors: [],
              filtersUpdated: true,
              processing: false,
            },
            () => {
              this.updateComponent = true;
              this.getSubscriptions();
            }
          );
        },
        (error) => {
          this.setState(
            {
              show: true,
              errors: error._user_message,
              success: "",
              processing: false,
            },
            () => {
              this.updateComponent = true;
            }
          );
        }
      );
    }
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    if (this.props.id !== undefined) {
      return true;
    }

    if (this.updateComponent === true) {
      this.updateComponent = false;
      return true;
    }

    return false;
  };

  render() {
    return (
      <React.Fragment>
        {this.props.id !== undefined ? (
          <Row>
            <Col md={12} lg={12} xl={12}>
              <div className="card__title">
                <div className="toolbar-buttons floatRight marginBottom20">
                  {this.printActions()}
                </div>
              </div>
            </Col>
          </Row>
        ) : (
          ""
        )}
        <Row>
          <Table
            className="table--head-accent table--bordered"
            responsive
            hover
          >
            {this.props.id === undefined ? (
              <thead>
                <tr>
                  <th key="id">Id</th>
                  <th key="uid">User Id</th>
                  {productHeaders.map((header, index) => (
                    <th key={index}>{header.name}</th>
                  ))}
                  <th>-</th>
                </tr>
              </thead>
            ) : (
              <thead>
                <tr>
                  <th key="id">Id</th>
                  {productHeaders.map((header, index) => (
                    <th key={index}>{header.name}</th>
                  ))}
                  <th>-</th>
                </tr>
              </thead>
            )}

            <tbody>{this.printRecords()}</tbody>
          </Table>
          {this.pagination()}
          {this.state.progress}
        </Row>
        <Slider
          isOpen={this.state.isOpen}
          footer={
            <div className="button-container">
              {this.state.processing === false ? (
                <React.Fragment>
                  <button
                    className="square btn btn-primary btn-sm"
                    onClick={this.submitForm}
                    type="button"
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="square btn btn-danger btn-sm"
                    onClick={() =>
                      this.setState({ isOpen: false }, () => {
                        this.updateComponent = true;
                      })
                    }
                  >
                    Cancel
                  </button>
                </React.Fragment>
              ) : (
                <button type="button" className="square btn btn-primary btn-sm">
                  Processing
                </button>
              )}
            </div>
          }
          onOutsideClick={() =>
            this.setState({ isOpen: false }, () => {
              this.updateComponent = true;
            })
          }
        >
          {
            <FormComponent
              title="Assign Product"
              toggleAddNew={this.toggleAddNew}
              handleForm={(formValues) => this.handleForm(formValues)}
              products={this.state.products}
              usages={this.state.usages}
              edit={this.state.edit}
              subnets={this.state.subnets}
              websites={this.props.websites}
              showError={(errors) =>
                this.setState({ show: true, errors: errors }, () => {
                  this.updateComponent = true;
                })
              }
            />
          }
        </Slider>

        <Slider
          isOpen={this.state.isOpenCredentials}
          footer={
            <div className="button-container">
              {this.state.processing === false ? (
                <React.Fragment>
                  <button
                    className="square btn btn-primary btn-sm"
                    onClick={this.submitForm}
                    type="button"
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="square btn btn-danger btn-sm"
                    onClick={() =>
                      this.setState({ isOpenCredentials: false }, () => {
                        this.updateComponent = true;
                      })
                    }
                  >
                    Cancel
                  </button>
                </React.Fragment>
              ) : (
                <button type="button" className="square btn btn-primary btn-sm">
                  Processing
                </button>
              )}
            </div>
          }
          onOutsideClick={() =>
            this.setState({ isOpenCredentials: false }, () => {
              this.updateComponent = true;
            })
          }
        >
          {
            <FormComponent
              title="Assign Product"
              toggleAddNew={this.toggleAddNew}
              handleForm={(formValues) => this.handleForm(formValues)}
              products={this.state.products}
              usages={this.state.usages}
              edit={this.state.edit}
              subnets={this.state.subnets}
              websites={this.props.websites}
              showError={(errors) =>
                this.setState({ show: true, errors: errors }, () => {
                  this.updateComponent = true;
                })
              }
            />
          }
        </Slider>

        <Slider
          isOpen={this.state.openProxies}
          footer={
            <div className="button-container">
              {this.state.edit.status === "active" ? (
                <button
                  className="square btn btn-primary btn-sm"
                  onClick={this.updateProxies}
                  type="button"
                >
                  Update Proxies
                </button>
              ) : (
                ""
              )}
              <button
                type="button"
                className="square btn btn-danger btn-sm"
                onClick={() =>
                  this.setState({ openProxies: false }, () => {
                    this.updateComponent = true;
                  })
                }
              >
                Close
              </button>
            </div>
          }
          onOutsideClick={() =>
            this.setState({ openProxies: false }, () => {
              this.updateComponent = true;
            })
          }
        >
          <ProfileProductProxies
            edit={this.state.edit}
            subnets={this.state.subnets}
            handleForm={(formValues) => this.handleForm(formValues)}
          />
        </Slider>
        <Slider
          isOpen={this.state.openProxiesArea}
          footer={
            <div className="button-container">
              {this.state.edit.status === "active" ? (
                <button
                  className="square btn btn-primary btn-sm"
                  onClick={this.updateProxiesTextarea}
                  type="button"
                >
                  Update Proxies
                </button>
              ) : (
                ""
              )}
              <button
                type="button"
                className="square btn btn-danger btn-sm"
                onClick={() =>
                  this.setState({ openProxiesArea: false }, () => {
                    this.updateComponent = true;
                  })
                }
              >
                Close
              </button>
            </div>
          }
          onOutsideClick={() =>
            this.setState({ openProxiesArea: false }, () => {
              this.updateComponent = true;
            })
          }
        >
          <ProfileProductProxiesTextArea
            edit={this.state.edit}
            subnets={this.state.subnets}
            handleForm={(formValues) => this.handleForm(formValues)}
          />
        </Slider>
        <Modal
          onClose={() =>
            this.setState({ show: false }, () => {
              this.updateComponent = true;
            })
          }
          show={this.state.show}
          errors={this.state.errors}
          success={this.state.success}
        ></Modal>
      </React.Fragment>
    );
  }
}

export default ProfileProducts;
